// extracted by mini-css-extract-plugin
export var productImage = "_qm-1";
export var viewLink = "_qm-2";
export var wishlistItem = "_qm-0";